module.exports = __webpack_public_path__ + "img/1.29037eae.jpg";